<template>
  <el-dialog title="选择收藏夹" :visible.sync="dialogVisible" width="400px" @closed="onClose">
    <div class="folder-list">
      <div class="folder-item" :class="{ active: selectedId === f.id }" v-for="f in folders" :key="f.id" @click="selectedId = f.id">
        <i class="el-icon-folder-opened"></i>
        <span class="folder-name">{{ f.name }}</span>
        <span class="folder-count">{{ f.count }} 项</span>
        <i class="el-icon-check check-icon" v-if="selectedId === f.id"></i>
      </div>
    </div>
    <div class="create-folder">
      <el-input v-model="newName" placeholder="输入新收藏夹名称" size="small" style="flex:1">
        <template #prepend><i class="el-icon-plus"></i></template>
      </el-input>
      <el-button type="primary" size="small" @click="handleCreate" :disabled="!newName.trim()">新建</el-button>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :disabled="!selectedId">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      selectedId: null,
      newName: '',
    }
  },
  watch: {
    'collectDialog.visible'(v) {
      if (v) this.$store.dispatch('fetchFolders')
    },
  },
  computed: {
    ...mapGetters(['folders', 'collectDialog']),
    dialogVisible: {
      get() { return this.collectDialog.visible },
      set(v) { if (!v) this.$store.dispatch('hideCollectDialog') },
    },
  },
  methods: {
    ...mapActions(['createFolder']),
    async handleCreate() {
      try {
        const folder = await this.createFolder({ name: this.newName.trim() })
        this.selectedId = folder.id
        this.newName = ''
      } catch (e) {
        this.$message.error('创建失败')
      }
    },
    async handleConfirm() {
      const mediaId = this.collectDialog.mediaId
      if (!mediaId || !this.selectedId) return
      try {
        const added = await this.$store.dispatch('toggleCollect', { mediaId, folderId: this.selectedId })
        if (added) this.$message.success('收藏成功')
        this.dialogVisible = false
      } catch (e) {
        this.$message.error('收藏失败')
      }
    },
    onClose() {
      this.selectedId = null
      this.newName = ''
      this.$store.dispatch('hideCollectDialog')
    },
  },
}
</script>

<style scoped>
.folder-list {
  max-height: 260px;
  overflow-y: auto;
  margin-bottom: 12px;
}
.folder-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;
}
.folder-item:hover { background: #f5f7fa; }
.folder-item.active { background: #ecf5ff; color: #409eff; }
.folder-item .folder-name { flex: 1; margin: 0 8px; font-size: 14px; }
.folder-item .folder-count { font-size: 12px; color: #999; }
.folder-item .check-icon { color: #409eff; font-size: 16px; }
.create-folder {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
